import { motion } from "framer-motion";

const principles = [
  {
    n: "01",
    name: "Calm over noise",
    body: "Every notification is a decision to interrupt a life. We interrupt rarely — and only when it matters.",
  },
  {
    n: "02",
    name: "Capacity over productivity",
    body: "Success is measured in well-being, not throughput. We will never ask you to do more.",
  },
  {
    n: "03",
    name: "Awareness over automation",
    body: "You stay in the pilot's seat. Life OS makes the horizon visible; the choices remain yours.",
  },
  {
    n: "04",
    name: "Breathing room is a resource",
    body: "Unstructured time is treated the same as money, energy, or people — a resource to defend.",
  },
  {
    n: "05",
    name: "Trust is earned in phases",
    body: "We observe first. Then suggest. Then advise. Then partner — only after we've proven accurate.",
  },
];

export default function Principles() {
  return (
    <section
      id="principles"
      data-testid="principles-section"
      className="relative border-t border-rule bg-deep/40 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-teal">
              05 — The principles
            </p>
            <h2 className="mt-6 font-display text-4xl leading-[1.05] text-ink md:text-5xl">
              What we refuse
              <br />
              <span className="italic text-mist">to compromise.</span>
            </h2>
            <p className="mt-6 max-w-sm text-base leading-relaxed text-mist">
              A short manifesto. Read it once. Hold us to it.
            </p>
          </div>

          <ol className="md:col-span-8">
            {principles.map((p, i) => (
              <motion.li
                key={p.n}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.6,
                  delay: i * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="grid grid-cols-12 gap-6 border-t border-rule py-8 first:border-t-0 first:pt-0 md:py-10"
              >
                <div className="col-span-2 font-mono text-[11px] uppercase tracking-[0.24em] text-teal">
                  {p.n}
                </div>
                <div className="col-span-10">
                  <h3 className="font-display text-2xl text-ink md:text-3xl">
                    {p.name}
                  </h3>
                  <p className="mt-3 max-w-2xl text-base leading-relaxed text-mist">
                    {p.body}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
